import { Injectable } from '@angular/core';
import { IgenomicsState } from '../../../core/interfaces/genomics-state.interface';
import { Store } from '@ngrx/store';
import { TEST_SUMMARY_ACTIONS } from '../constants/test-summary.constants';
import { reviewItem } from '../constants/review-item.constants';
import * as immutable from 'immutable';
import { Observable } from 'rxjs/Observable';
import { InterpreationSummary } from '../interfaces/interpreation-summary.interface';
import { AnyARecord, AnyNaptrRecord } from 'dns';

@Injectable()
export class TestSummaryActionsService {
  private store$: any;
  private userID: string;
  private readonly baseUrl = '/Report';
  private readonly baseTestUrl = '/test';
  private readonly baseValuesetUrl = '/valueset';
  private readonly baseNewReportUrl = '/report';

  public interpreationSummaries$: Observable<Array<InterpreationSummary>>;

  constructor(store: Store<IgenomicsState>) {
    this.store$ = store.select('tests', 'testSummary');
    this.interpreationSummaries$ = this.store$.select('interpretationSummaries');
  }

  public setReview(fileType: filesType | string, id: string, review: string = '') {
    let action;
    fileType = typeof fileType === 'string' ? filesType[fileType] : fileType;
    switch (fileType) {
      case filesType.finalReview:
        action = TEST_SUMMARY_ACTIONS.SET_FINAL;
        break;
      case filesType.addendumReview:
        action = TEST_SUMMARY_ACTIONS.SET_ADDENDUM;
        break;
      default:
        return false;
    }
    this.store$.dispatch({
      type: action,
      payload: {
        id,
        review,
        userID: this.userID
      }
    });
  }

  public storedReview$(id: string) {
    return this.store$.select('reviews')
      .map((reviews: any) => {
        return reviews.has(id)
          ? reviews.get(id).asMutable()
          : immutable.fromJS(reviewItem).asMutable();
      })
  }

  public getStoredReview(id: string): Promise<string> {
    return this.storedReview$(id)
      .take(1)
      .toPromise();
  }

  public initReview(id) {
    this.store$.dispatch({
      type: TEST_SUMMARY_ACTIONS.INIT_REVIEWS,
      payload: {
        id,
        userID: this.userID
      }
    });
  }

  public setState(state, userID: string) {
    this.userID = userID;
    this.store$.dispatch({
      type: TEST_SUMMARY_ACTIONS.SET_STATE,
      payload: {
        state,
        userID: this.userID
      }
    });

  }

  initInterpretationSummaries(summaries: InterpreationSummary[]): void {
    this.store$.dispatch({
      type: TEST_SUMMARY_ACTIONS.SET_SUMMARIES,
      payload: summaries
    });
  }


  /*  Migrated Methods methods from TestSummary Service */

  public getInterpretationSummary(revisionId: AnyNaptrRecord){
    // return this._http.get(this.baseUrl + '/getInterpretationSummary', {revisionId: revisionId})
  }

  public releaseAddendumReport(addendum: AnyARecord){
    // return this._http.post(this.baseUrl + '/releaseAddendumReport', addendum)
  }

  public getRelatedControlTests(revisionId, testType){
    // return this._http.get(this.baseTestUrl + '/getRelatedControlTests',  {workflowId: revisionId, testType: testType})
  }

  public getControlSampleStatuses(){
    // return this._http.get(this.baseValuesetUrl + '/getNavicanControlTestStatuses', {})
  }

  public postReportToEmr(workflowId, revisionId){
    // let data = {
    //   workflowId: workflowId,
    //   revisionId: revisionId,
    // };
    //
    // let config = {
    //   headers: {
    //     'Content-Type': 'application/json'
    //   }
    // }
    //
    // return this._http.post(this.baseNewReportUrl + '/sendToEmr', data,false,config.headers).subscribe((res: any) =>{
    //   (res && res.data) ? true : false
    // }), err => {
    //   console.log(err);
    //   false
    // };
  }

}

export enum filesType {
  finalReview,
  addendumReview
}
